import Blue from "~/core";

new Blue({
  name: "Header Nav Menu",
  selector: ".header",
  setup(header) {
    const nav = header.querySelector(".header__nav");
    const drawer = header.querySelector(".header__drawer");
    const drawerInner = header.querySelector(".header__drawer-inner");
    const mainUtilLinks = header.querySelector(".header__util-links--main");
    const mobileUtilLinks = header.querySelector(".header__mobile-util");
    const mobileSearch = header.querySelector(".header__mobile-search");
    const navToggle = header.querySelector(".header__nav-toggle");
    const topLevelItems = nav.querySelectorAll(".has-submenu");
    const search = header.querySelector(".header__search");
    const loginForm = document.querySelector(".header__util-login");
    const media = window.matchMedia(`(min-width: 992px)`);
    const accordions = header.querySelectorAll(".menu-accordion");

    // CHECK TO SEE IF THERE IS AN APP BANNER
    const calculateHeaderHeight = () => {
      if (!media.matches) {
        setTimeout(() => {
          header.classList.remove("is-open");
          setHeaderHeightValues();
        }, 0);
      } else {
        setTimeout(() => {
          header.classList.remove("is-open");
          setHeaderHeightValues({drawerVal: null});
        }, 0);
      }
    };
    // calculateHeaderHeight();

    const observer = new ResizeObserver((entries) => {
      entries.forEach(() => {
        header.classList.remove("is-open");
        setHeaderHeightValues();
        [...nav.querySelectorAll(".is-open")].forEach((i) => {
          i.classList.remove("is-open")
          item.setAttribute("aria-expanded", "false");
        }
        );
        this.$scrollLock.unlock(header);
      });
    });
    observer.observe(header);

    topLevelItems.forEach((item) => {
      const link = item.querySelector(":scope > .header__nav-link");
      const menuTriggers = link.matches("span") ? link : false;

      this.$addEvents(menuTriggers, "click.stop enter.prevent", () => {
        if (this.$screen.lg) {
          const siblings = [
            ...item.parentElement.querySelectorAll(":scope > .has-submenu"),
          ].filter((itm) => itm != item);
          siblings.forEach((sibling) => {
            sibling.classList.remove("is-open");
            sibling.setAttribute("aria-expanded", "false");
          });
          if (item.classList.contains("is-open")) {
            item.classList.remove("is-open");
            item.setAttribute("aria-expanded", "false");
          } else {
            item.classList.add("is-open");
            loginForm.classList.remove("is-open");
            search.classList.remove("is-open");
            item.setAttribute("aria-expanded", "true");
          }
        }
      });
    });

    // TOGGLE MOBILE MENU
    this.$addEvents(navToggle, "click.prevent enter.prevent", () => {
      if (!this.$screen.lg.matches) {
        header.classList.toggle("is-open");
        loginForm.classList.remove("is-open");
        this.$scrollLock.lock(header);
        if (!header.classList.contains("is-open")) {
          [...nav.querySelectorAll(".is-open")].forEach((i) =>
            i.classList.remove("is-open")
          );
          this.$scrollLock.unlock(header);
        }
        if (search != null) search.classList.remove("is-open");
        toggles.forEach((t) => t.close());
      }
    });

    // MOBILE ACCORDION MENUS
    const accordionMedia = window.matchMedia(`(max-width: 991px)`);
    const toggles = [];
    accordions.forEach((accordion) => {
      let trigger = accordion.querySelector(
        ":scope > .menu-accordion__item span"
      );
      let content = accordion.querySelector(
        ":scope > .menu-accordion__content"
      );
      let config = { trigger, content, media: accordionMedia };

      toggles.push(new this.$toggle(config));
    });

    accordionMedia.addEventListener("change", () => {
      toggles.forEach((t) => t.close());
    });

    // move main nav for mobile
    this.$retach(nav, {
      destination: drawerInner,
      mediaQuery: 991,
    });
    // move utility nav for mobile
    this.$retach(mainUtilLinks, {
      destination: mobileUtilLinks,
      mediaQuery: 991,
    });
    // move search for mobile
    this.$retach(search, {
      destination: mobileSearch,
      mediaQuery: 991,
    });

    // CLOSE MENU WHEN CLICKING OUTSIDE
    this.$addEvents(window, "click", (e) => {
      if (!this.$screen.lg.matches) return;
      if (e.target.closest(".menu-accordion--secondary")) return;
      [...nav.querySelectorAll(".is-open")].forEach((i) => {
        i.classList.remove("is-open");
        i.setAttribute("aria-expanded", "false");
      });
    });

    function setHeaderHeightValues({drawerVal} = {}) {
      let additionalHeight = 0;
      const sitemapSticky = document.querySelector(".sitemap-anchors");

      if (sitemapSticky) {
        additionalHeight = sitemapSticky.offsetHeight;
      }

      document.body.style.marginTop = `${header.offsetHeight}px`;
      document.documentElement.style.setProperty(
        "--header-height",
        `${header.offsetHeight + additionalHeight}px`
      );
      drawer.style.marginTop = `${drawerVal || header.offsetHeight}px`;
    }
  },
});

new Blue({
  name: "Header Search",
  selector: ".header__search",
  setup(search) {
    if (search != null) {
      const header = document.querySelector(".header");
      const searchToggle = header.querySelector(".header__nav-search");
      const searchInput = header.querySelector("#top-search-box");
      const searchClose = header.querySelector(".header__search-close");
      const nav = header.querySelector(".header__nav");

      this.$addEvents(
        [searchToggle, searchClose],
        "click.prevent enter.prevent",
        () => {
          search.classList.toggle("is-active");
          header.classList.remove("is-open");
          [...nav.querySelectorAll(".is-open")].forEach((i) => {
            i.classList.remove("is-open");
            i.setAttribute("aria-expanded", "false");
          });
          setTimeout(() => {
            searchInput.focus();
          }, 100);
        }
      );

      this.$screen.lg.addListener((e) => {
        search.classList.remove("is-open");
      });
    }
  },
});

new Blue({
  name: "Header Login",
  selector: ".header__util-login",
  setup(login) {
    const loginButton = login.parentElement.querySelector(
      ".header__util-link--login"
    );
    const loginClose = login.parentElement.querySelector(
      ".header__util-login-close"
    );
    const memberInput = document.querySelector("#username");
    const memberPass = document.querySelector("#password");
    const search = document.querySelector(".header__search");
    const passwordToggle = document.querySelector("#showpassword");

    this.$addEvents(loginClose, "click.prevent enter.prevent", () => {
      login.classList.toggle("is-open");
    });
    this.$addEvents(passwordToggle, "click enter", () => {
      if (passwordToggle.checked) {
        memberPass.type = "text";
      } else {
        memberPass.type = "password";
      }
    });
    this.$addEvents(loginButton, "click.prevent enter.prevent", () => {
      login.classList.toggle("is-open");
      search.classList.remove("is-open");
      memberInput.focus();
    });

    const loginSubmit = login.querySelector('button[type="submit"]');

    this.$addEvents(loginSubmit, "click.prevent enter.prevent", (e) => {
      e.preventDefault();
      let username = login.querySelector("#username").value;
      let password = login.querySelector("#password").value;
      submitLogin(username, password);
    });

    function postForm(url, params, method, newTab) {
      method = method || "post";
      newTab = newTab || false;

      let form = document.createElement("form");
      form.setAttribute("method", method);
      form.setAttribute("action", url);
      if (newTab) {
        form.setAttribute("target", "_blank");
      }

      for (let key in params) {
        if (params.hasOwnProperty(key)) {
          let field = document.createElement("input");
          field.setAttribute("type", "hidden");
          field.setAttribute("name", key);
          field.setAttribute("value", params[key]);
          form.appendChild(field);
        }
      }

      document.body.appendChild(form);
      form.submit();
    }

    function submitLogin(username, password) {
      let params = {};
      params.user_id = username;
      params.password = password;

      if (username.trim() && password.trim()) {
        postForm(
          "https://onlinebanking.fccu.org/FCCUOnline/uux.aspx",
          params,
          "post"
        );
      }
    }

    const capsWarning = login.querySelector(".form__caps-warning");
    const loginInputs = [...login.querySelectorAll("input")];

    loginInputs.forEach((i) => {
      if (i.type !== "checkbox") {
        i.addEventListener("input", (e) => {
          if (e.data.length === 1 && /^[a-zA-Z0-9]+$/.test(e.data)) {
            if (
              e.data.toUpperCase() === e.data &&
              e.data.toLowerCase() !== e.data &&
              !e.shiftKey
            ) {
              capsWarning.classList.add("show");
            } else {
              capsWarning.classList.remove("show");
            }
          }
        });
      }
    });
  },
});
